module.exports = __webpack_public_path__ + "img/4.2404e388.jpg";